import {
  type DefaultError,
  type QueryKey,
  type UseQueryOptions,
  useQuery,
} from "@tanstack/react-query";
import { useState } from "react";

export function usePaginateQuery<
  TQueryFnData = unknown,
  TError = DefaultError,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(
  options: (
    page: number | undefined,
  ) => UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
  initialPage: number | undefined = undefined,
) {
  const [page, setPage] = useState(initialPage);

  return {
    ...useQuery({
      ...options(page),
      //placeholderData: keepPreviousData
    }),
    page,
    setPage,
    next: () => setPage((page) => (page || 1) + 1),
    prev: () => setPage((page) => (page || 1) - 1),
  };
}
